import {Modality} from "util/globalEnums";

/**
 * Mapear todos os labels possíveis
 */
export type LabelKey =
  | "knowledge.master.title"
  | "knowledge.house.title"
  | "knowledge.master.number"
  | "knowledge.house.number"
  | "knowledge.master.directMaster";

/**
 * Mapeia as labels. Notar que nem todas as modalidades possuem todas as labels.
 */
type LabelsMap = Record<Modality, Partial<Record<LabelKey, string>>>;

const labels: LabelsMap = {
  [Modality.Marítima]: {
    "knowledge.master.title": "BL Master",
    "knowledge.house.title": "BL House",
    "knowledge.master.number": "BL n°",
    "knowledge.house.number": "BL n°",
    "knowledge.master.directMaster": "BL Direto",
  },
  [Modality.Aérea]: {
    "knowledge.master.title": "MAWB",
    "knowledge.house.title": "HAWB",
    "knowledge.master.number": "MAWB n°",
    "knowledge.house.number": "HAWB n°",
    "knowledge.master.directMaster": "AWB Direto",
  },
  [Modality.Terrestre]: {
    "knowledge.master.title": "BL Master",
    "knowledge.house.title": "BL House",
    "knowledge.master.number": "BL n°",
    "knowledge.house.number": "BL n°",
    "knowledge.master.directMaster": "BL Direto",
  },
};

/**
 * Para efeitos de modularização, caso essa feature seja estendida para outras telas
 * essa função pode ser generalizada, mas manter um arquivo de labels para cada módulo, e não um global.
 */
export const getProcessLabel = (
  labelKey: LabelKey,
  modality: Modality,
): string => {
  if (
    ![Modality.Marítima, Modality.Terrestre, Modality.Aérea].includes(modality)
  ) {
    return "-";
  }

  const label = labels[modality][labelKey];
  const defaultLabel = "-";
  if (!label) {
    return labels?.[modality]?.[labelKey] ?? defaultLabel;
  }
  return label;
};
